import { Object3D } from "three";
import { AddonManager } from "../scene/addon/AddonManager";

export interface IEnvironmentObjectConfig
{
	id: string;
	x: number;
	y: number;
	scale?: number | number[];
	rotation?: number;
}

export class EnvironmentObject
{
	private _config: IEnvironmentObjectConfig;

	private _container: Object3D;

	constructor(config: IEnvironmentObjectConfig)
	{
		this._config = config;

		this._container = AddonManager.getInstance().createMesh(this._config.id);
		this._container.position.x = this._config.x;
		this._container.position.z = this._config.y;

		var scale = this._config.scale;
		if (scale)
		{
			if (Array.isArray(scale))
			{
				this._container.scale.set(scale[0], scale[1], scale[2]);
			}
			else
			{
				var scaleNum = <number>scale;
				this._container.scale.set(scaleNum, scaleNum, scaleNum);
			}
		}

		if (this._config.rotation)
		{
			this._container.rotation.y = this._config.rotation * Math.PI / 180;
		}
	}

	public get container()
	{
		return this._container;
	}
}